import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Loader, TextInput } from 'kangarootime-ui';
import TimecardsTable from './TimecardsTable';

const EmployeeTimecards = ({
  byEmployee,
  loading,
  onRowSelect,
  ...props
}) => {
  const [filterValue, setFilterValue] = useState('');
  const filteredEmployeeList = useMemo(() => {
    if (!filterValue) {
      return byEmployee;
    }

    // filter object values by the object's employee name
    return Object.keys(byEmployee).reduce((prev, currentKey) => {
      const currentValue = byEmployee[currentKey];
      const { name } = currentValue;

      if (name.toLowerCase().includes(filterValue)) {
        prev[currentKey] = currentValue;
      }

      return prev;
    }, {});
  }, [filterValue, byEmployee]);

  return (
    <Loader loading={loading}>
      <div className='flex' style={{ margin: '8px 0', justifyContent: 'flex-end' }}>
        <TextInput
          placeholder='Filter Employees'
          value={filterValue}
          onChange={event => setFilterValue(event.target.value)}
        />
      </div>
      <TimecardsTable
        byEmployee={filteredEmployeeList}
        onRowSelect={onRowSelect}
      />
    </Loader>
  );
};

EmployeeTimecards.propTypes = {
  byEmployee: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      name: PropTypes.string,
      timecards: PropTypes.arrayOf(PropTypes.object)
    })
  }),
  loading: PropTypes.bool,
  onRowSelect: PropTypes.func
};

EmployeeTimecards.defaultProps = {
  byEmployee: {},
  loading: false,
  onRowSelect: () => {}
};

export default EmployeeTimecards;
